import type { FunctionComponent } from "react";
import { WebsiteChipItem } from "@similarweb/ui-components";
import { IconButton } from "@similarweb/ui-components";
import { InfoIcon } from "pro-features/components/BoxTitle/src/BoxTitle";
import { PlainTooltip } from "app/components/React/Tooltip/PlainTooltip/PlainTooltip";
import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import { ProgressBar } from "app/components/React/ProgressBar/ProgressBar";
import { CHART_COLORS } from "app/constants/ChartColors";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import {
    BoxLinksStyled,
    LinkChannelName,
    LinkHeaderContainer,
    LinkNumber,
    LinkPixelPlaceholderLoaderStyled,
    LinkProgressBarContainer,
    LinkRowContainer,
    LinkText,
    LinkTitle,
    RowLink,
} from "app/pages/digital-suite/styledComponents";
import { i18nFilter } from "app/filters/i18nFilter";

interface IBoxLinksProps {
    data: { [name: string]: number };
    name: string;
    links: { titleKey: string; id: string; stateLink: string }[];
    image: string;
    countryName: string;
    isLoadingData: boolean;
    isLoadingImage: boolean;
    onClearClick: () => void;
    onItemClick: (siteName: string, channelName: string, state: string, visits: string) => void;
}

const i18n = i18nFilter();

export const BoxLinks: FunctionComponent<IBoxLinksProps> = ({
    data,
    name,
    links,
    image,
    isLoadingData,
    isLoadingImage,
    onClearClick,
    onItemClick,
    countryName,
}) => {
    const ItemRew = (rew, index) => {
        const hasData = data[rew.id] > 0;
        const channelVisitPercentage = hasData ? data[rew.id] + "%" : "N/A";
        return (
            <RowLink onClick={() => onItemClick(name, rew.id, rew.stateLink, channelVisitPercentage)}>
                <LinkChannelName>{i18n(rew.titleKey)}</LinkChannelName>
                {isLoadingData ? (
                    <FlexRow>
                        <LinkPixelPlaceholderLoaderStyled
                            width={101}
                            height={12}
                        />
                        <PixelPlaceholderLoader
                            width={101}
                            height={12}
                        />
                    </FlexRow>
                ) : (
                    <LinkRowContainer>
                        <FlexRow>
                            <LinkNumber>{channelVisitPercentage}</LinkNumber>
                            &nbsp;
                            {hasData ? <LinkText>{i18n("acquisition.home.page.link.visits.text")}</LinkText> : null}
                            &nbsp;
                        </FlexRow>
                        <LinkProgressBarContainer>
                            <ProgressBar
                                width={data[rew.id]}
                                innerColor={CHART_COLORS.trafficSourcesColorsBySourceMMX[rew.id]}
                                isCompare={false}
                            />
                        </LinkProgressBarContainer>
                    </LinkRowContainer>
                )}
            </RowLink>
        );
    };
    return (
        <BoxLinksStyled
            width={"608px"}
            height={"auto"}
        >
            <LinkHeaderContainer>
                <WebsiteChipItem
                    image={image}
                    text={name}
                    className={"AcquisitionHomePageLinksSiteChip"}
                    imageAlt={""}
                    hideActionButton={true}
                />
                <IconButton
                    type="flat"
                    iconName={"clear"}
                    onClick={onClearClick}
                >
                    {i18n("acquisition.home.page.links.button")}
                </IconButton>
            </LinkHeaderContainer>
            <LinkHeaderContainer>
                <LinkTitle>{i18n("acquisition.home.page.links.title")}</LinkTitle>
                <PlainTooltip
                    placement="top"
                    text={i18n("acquisition.home.page.links.tooltip", { country: countryName })}
                >
                    <span>
                        <InfoIcon iconName="info" />
                    </span>
                </PlainTooltip>
            </LinkHeaderContainer>
            {links.map(ItemRew)}
        </BoxLinksStyled>
    );
};
